module.exports = __webpack_public_path__ + "img/d8a5f42.png";